export default "__VITE_ASSET__0b42f442__"